import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { subscribeToLogout } from '../../auth/authSync';
import { applyRemoteLogout } from '../../auth/logout';

export const LogoutSync = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => subscribeToLogout(() => {
    dispatch(applyRemoteLogout()).then(() => {
      navigate('/', { replace: true });
    });
  }), [dispatch, navigate]);

  return null;
};
